import React, { Component } from "react";
import { authService } from "../auth";
import { Link } from "react-router-dom";
import CleverTapUtils from "../commons/CleverTapUtils";

class CommonFeedsZeroData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage()
        };
    }

    render() {
        return (
            <div className="zdata zfeed">
                <div className="imgbox">
                    <img src="https://cdn.dscovr.com/images/zroProjectsActivity.webp"
                        onError={(e) => { e.target.onerror = null; e.target.src = "https://cdn.dscovr.com/images/zroProjectsActivity.png" }}
                        alt="" />
                </div>
                <div className="desc">
                    <h2>Hello!</h2>
                    <h3>Welcome to this new world of nature.</h3>
                    {this.state.userData.type !== "COMPANY" ?
                        <div>
                            <p>Make new connections and explore possibilities.</p>
                            <p><Link to="/popular-users" className="zerotab" onClick={() => {{CleverTapUtils.eventClick({}, "Display Popular Users List");}}}>Connect Now</Link></p>
                        </div>
                        :
                        <div><p>Let the world learn about your work and activities.</p>
                            <p><a href="#addpostpop" data-toggle="modal">Post here</a></p></div>}
                </div>
            </div>
        )
    }
}

export default CommonFeedsZeroData;